<template>
    <div class="card-info panel grid grid-2-3-3">
        <div>
            <p v-bastards
               class="card-info-label fs-17 text-bold">Dane na karcie:</p>
            <p v-bastards
               class="card-info-lead fs-27 text-upper">{{ fullName }}</p> 
            <p v-bastards
               class="card-info-label fs-17 text-bold">Numer karty:</p> 
            <p v-bastards
               class="fs-19">{{ number }}</p>
        </div> 
        <div>
            <p v-bastards
               class="card-info-label fs-17 text-bold">Dane firmy:</p>
            <p v-bastards
               class="card-info-lead fs-27 text-upper">{{ companyName }}</p> 
            <div class="card-info-group">
                <p 
                    v-bastards
                    v-for="line in companyData"
                    :key="line"
                    class="fs-19 fs-lh-21"
                    v-text="line"
                />
            </div>
        </div>
        <div>
            <p v-bastards
               class="card-info-label fs-17 text-bold">Info:</p>
            <p
                v-bastards
                class="fs-19 fs-lh-21"
            >
                Dane nieaktualne?<br>
                Możesz je zaktualizować w swojej hali rejestracji przed następnymi zakupami.
            </p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        number: {
            type: String,
            required: false,
            default: ''
        },
        fullName: {
            type: String,
            required: false,
            default: ''
        },
        companyName: {
            type: String,
            required: false,
            default: ''
        },
        companyData: {
            type: Array,
            required: false,
            default: () => []
        }
    }
}
</script>

<style lang="scss">
.card-info {
    padding: 35px 52px 45px;
    margin-bottom: 8px;

    &-label {
        padding: 0 0 10px;
    }

    &-lead {
        & + .card-info-label {
            padding-top: 16px;
        }

        & + .card-info-group {
            padding-top: 32px;
        }
    }

    &.grid {
        > * {
            &:nth-child(2) {
                position: relative;
                padding-left: 40px;

                &:before {
                    content: '';
                    background-color: $color-border-light;
                    position: absolute;
                    top: 0;
                    bottom: 0;
                    left: -20px;
                    width: 1px;
                }
            }
        }
    }

    @media (max-width: $screen-laptop) {
        padding: 35px 30px 45px;
    }

    @media (max-width: $screen-tablet) {
        &.grid {
            display: block;

            > *,
            > *:nth-child(2) {
                &:before {
                    display: none;
                }
                
                padding-left: 0;
                padding-top: 20px;
            }
        }
    }
}
</style>
